import Class from './c-menu';
import './c-menu@';

export default Class;